/**
 * functions
 */
import { updateLazy } from "Functions/lazy";
import { initTippy } from "Functions/tippy";
import { fetchUserPrices } from "Functions/fetch-user-prices";
import { initializeCartAddSelect } from "Functions/cart-add";
import { initCountdowns } from "Functions/countdown";
import { initAllSmartForms } from "Common/smartform";

/**
 * common & components
 */
import "Common/app";
import "Common/app-smart-banner";
import "Common/eshop";
import "Common/window";
import "Common/info-messages";
import "Common/toggle-password";
import "Common/wishlist-vue";
import "Common/scheduled";
import "Common/global";
import "Common/modal-switch";
import "Common/backBtn";
import "Common/switch-cookie";
import "Common/flutter-logout";

import "Common/product-cart-quantity";
import "Common/spinner-quick-update";

import "Common/social";

import "Components/modal/modal-back";
import "Components/modal/modal-jump";
import "Components/modal/modal-watchdog";
import "Components/modal/modal-product-request";
import "Components/modal/product-detail-modal";

import "Components/header";
import "Components/footer";
import "Components/overdue-invoices-modal";
import "Ui/pay-invoice-trigger";

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.rEvent.dispatch("Custom.Cart.addedItem", { form, response });
};
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.rEvent.dispatch("Custom.Cart.updatedItem", { input, response });
};
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.rEvent.dispatch("Custom.Cart.removedItem", { form, response });
};

window.updateLazy = updateLazy();

document.addEventListener("DOMContentLoaded", () => {
    initAllSmartForms();
    updateLazy();
    initTippy();
    initCountdowns();
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-back").forEach((back) => {
        back.addEventListener("click", (event) => {
            const href = event.currentTarget.getAttribute("href");

            if (!href || href == "#") {
                event.preventDefault();
                window.history.back();
            }
        });
    });
});

fetchUserPrices();
initializeCartAddSelect();

rEvent.on("Listing.fetchedData", () => {
    fetchUserPrices();
    initializeCartAddSelect();
    initCountdowns();
});

// Store cart totals globally when fetched (from minicart or other sources)
rEvent.on("Custom.Cart.fetchedTotals", ({ response }) => {
    if (response?.data?.totals) {
        window.Eshop = window.Eshop || {};
        window.Eshop.cartTotals = response.data.totals;
    }
});

// Update competition modal with cart totals when opened
$(document).on("shown.bs.modal", "#competition-modal", function () {
    const modalEl = document.getElementById("competition-modal");
    if (!modalEl) return;

    const modal = modalEl.querySelector(".c-competition-modal[data-base-spent]");
    if (!modal) return;

    // Get cart subtotal from globally stored totals
    let cartSubtotal = 0;
    const totals = window.Eshop?.cartTotals;

    if (totals) {
        const pricesWithVat = window.Eshop?.options?.pricesWithVat;
        cartSubtotal = pricesWithVat ? totals.total || 0 : totals.subtotal || 0;
    }

    if (cartSubtotal <= 0) return;

    const baseSpent = parseFloat(modal.dataset.baseSpent) || 0;
    const finalThreshold = parseFloat(modal.dataset.finalThreshold) || 0;
    const milestones = JSON.parse(modal.dataset.milestones || "[]");

    // Calculate new spent with cart
    const spentWithCart = Math.min(baseSpent + cartSubtotal, finalThreshold);
    const isCompleted = spentWithCart + 0.00001 >= finalThreshold;
    const remainingToFinal = Math.max(0, finalThreshold - spentWithCart);

    // Update note text
    const noteEl = modal.querySelector(".js-competition-modal-note");
    if (noteEl) {
        if (isCompleted) {
            noteEl.innerHTML = modal.dataset.textCompleted || "";
        } else {
            const template = modal.dataset.textRemaining || "";
            noteEl.innerHTML = template.replace(
                "{amount}",
                "<strong>" + Format.price(remainingToFinal) + "</strong>"
            );
        }
    }

    // Update spent amount display
    const amountEl = modal.querySelector(".js-competition-modal-amount .js-spent");
    if (amountEl) {
        amountEl.innerHTML = Format.price(spentWithCart);
    }

    // Update bar segments
    const segments = modal.querySelectorAll(".c-competition-modal__bar .sc-segment");
    let prevThreshold = 0;

    segments.forEach((segment, index) => {
        if (index >= milestones.length) return;

        const milestone = milestones[index];
        const threshold = milestone.threshold;
        const range = threshold - prevThreshold;
        const reached = spentWithCart + 0.00001 >= threshold;
        const fill =
            range > 0
                ? Math.max(0, Math.min(1, (spentWithCart - prevThreshold) / range)) * 100
                : reached
                ? 100
                : 0;

        segment.classList.toggle("is-reached", reached);
        const fillEl = segment.querySelector(".sc-segment__fill");
        if (fillEl) {
            fillEl.style.width = fill + "%";
        }

        prevThreshold = threshold;
    });

    // Update bar labels
    const labels = modal.querySelectorAll(".c-competition-modal__bar-labels .sc-label");
    prevThreshold = 0;

    labels.forEach((label, index) => {
        if (index >= milestones.length) return;

        const milestone = milestones[index];
        const threshold = milestone.threshold;
        const reached = spentWithCart + 0.00001 >= threshold;

        let labelValue = null;
        if (reached) {
            labelValue = threshold;
        } else if (spentWithCart > prevThreshold) {
            labelValue = spentWithCart;
        }

        label.innerHTML =
            labelValue !== null ? "<strong>" + Format.price(labelValue) + "</strong>" : "";

        prevThreshold = threshold;
    });

    // Update milestone cards
    const milestoneCards = modal.querySelectorAll(".js-competition-milestone");

    milestoneCards.forEach((card) => {
        const threshold = parseFloat(card.dataset.threshold) || 0;
        const reached = spentWithCart + 0.00001 >= threshold;
        const current = Math.min(spentWithCart, threshold);

        card.classList.toggle("is-reached", reached);

        const checkIcon = card.querySelector(".js-check-icon");
        if (checkIcon) {
            checkIcon.classList.toggle("hidden", !reached);
        }

        const currentEl = card.querySelector(".js-current");
        if (currentEl) {
            currentEl.innerHTML = Format.price(current);
        }
    });
});
